import React from "react";
import Orders from "./Orders";

function Exchange({ orders }) {
  return (
    <div>
      <h1 className="dashboard-heading">Exchange and Return Orders</h1>
      <Orders orders={orders} />
    </div>
  );
}

export default Exchange;

